import React, { Component } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import getPersonName from "../common/Name";
import { getDate } from "../common/DisplayDate";
import getSsn from "../common/Ssn";
import Address from "./Address";

class WatercraftRecordDetail extends Component {
  componentDidMount() {}

  render() {
    const results = [];
    const { node } = this.props;
    if (node !== undefined && node !== null) {
      const name = _.get(node, "owners[0].owner[0].name[0]");
      results.push(
        <Table.Row key={`Watercraft_Record_Name_Row_${this.props.index}`}>
          <Table.Cell>Name:</Table.Cell>
          <Table.Cell>
            {name &&
              getPersonName(
                _.get(name, "first[0]._", ""),
                "",
                _.get(name, "last[0]._", ""),
                this.props
              )}
          </Table.Cell>
          <Table.Cell>Date Last Seen:</Table.Cell>
          <Table.Cell>{getDate(_.get(node, "dateLastSeen[0]"))}</Table.Cell>
        </Table.Row>
      );
      results.push(
        <Table.Row key={`Watercraft_Record_Ssn_Row_${this.props.index}`}>
          <Table.Cell>SSN:</Table.Cell>
          <Table.Cell>
            {getSsn(_.get(node, "owners[0].owner[0].SSN[0]._"), this.props)}
          </Table.Cell>
          <Table.Cell>Registration Date:</Table.Cell>
          <Table.Cell>{getDate(_.get(node, "registrationDate[0]"))}</Table.Cell>
        </Table.Row>
      );

      results.push(
        <Table.Row key={`Watercraft_Record_Address_Row_${this.props.index}`}>
          <Table.Cell>Address:</Table.Cell>
          <Table.Cell>
            <Address
              addressNode={_.get(node, "owners[0].owner[0].address[0]")}
              {...this.props}
            />
          </Table.Cell>
          <Table.Cell>Registration Number:</Table.Cell>
          <Table.Cell>{_.get(node, "registrationNumber[0]._", "")}</Table.Cell>
        </Table.Row>
      );
      results.push(
        <Table.Row key={`Watercraft_Record_Vessel_Row_${this.props.index}`}>
          <Table.Cell>Vessel Name:</Table.Cell>
          <Table.Cell>{_.get(node, "vesselName[0]._", "")}</Table.Cell>
          <Table.Cell>State of Origin:</Table.Cell>
          <Table.Cell>{_.get(node, "stateOrigin[0]._", "")}</Table.Cell>
        </Table.Row>
      );
      results.push(
        <Table.Row key={`Watercraft_Record_Hull_Row_${this.props.index}`}>
          <Table.Cell>Hull Number:</Table.Cell>
          <Table.Cell>{_.get(node, "hullNumber[0]._", "")}</Table.Cell>
          <Table.Cell />
          <Table.Cell />
        </Table.Row>
      );
    }

    return (
      <Table>
        <Table.Body>{results}</Table.Body>
      </Table>
    );
  }
}

export default WatercraftRecordDetail;



// WEBPACK FOOTER //
// ./src/components/searchresults/WatercraftRecordDetail.js